import { Link } from 'react-router-dom';
import './HowItWorksPage.css';

function IconCamera() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.5" y="7" width="17" height="12.5" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M9 7l1.2-2.2h3.6L15 7" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <circle cx="12" cy="13.2" r="3.1" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

function IconMatch() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="9" cy="9" r="3.2" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="16.5" cy="10.5" r="2.6" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M4.5 18.5c.7-2.4 2.6-3.8 4.5-3.8s3.8 1.4 4.5 3.8M14 14.8c1.4-.3 2.9.4 3.8 2.2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function IconTruck() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M3.5 7.5h10.5v9H3.5v-9zM14 10.5h3.2l2.8 3v3H14v-6z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="7.2" cy="17.8" r="1.6" fill="currentColor" />
      <circle cx="17.2" cy="17.8" r="1.6" fill="currentColor" />
    </svg>
  );
}

function IconCheck() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 3.5l7 2.5v5.2c0 4.3-2.9 7.3-7 9.3-4.1-2-7-5-7-9.3V6L12 3.5z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M9.2 12.1l1.9 1.9 3.7-3.9"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconBadge() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M8 4.5h6l4 4V19a1.5 1.5 0 0 1-1.5 1.5H8A1.5 1.5 0 0 1 6.5 19V6A1.5 1.5 0 0 1 8 4.5z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path d="M14 4.8V9h4M9.5 13h5M9.5 16h3.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconSearch() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="6.2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M16 16l4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function IconChat() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M5 7.5A2.5 2.5 0 0 1 7.5 5h9A2.5 2.5 0 0 1 19 7.5v6A2.5 2.5 0 0 1 16.5 16H10l-4 3v-3H7.5A2.5 2.5 0 0 1 5 13.5v-6z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconRecycle() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M7.5 8.5l2-3.5h5l2 3.5M16.5 15.5l-2 3.5h-5l-2-3.5M5.5 12.5H3.2l1.5-3M18.5 12.5h2.3l-1.5 3"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.5 8.5l-1.8 3M14.5 15.5l1.8-3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
}

const POSTER_STEPS = [
  {
    n: '01',
    title: 'Create a free scrap post',
    body: 'Add photos, your postcode, and a short description of the metal you need collected.',
    Icon: IconCamera,
  },
  {
    n: '02',
    title: 'Get matched with collectors',
    body: 'Nearby licensed collectors review your listing and arrange a convenient collection time.',
    Icon: IconMatch,
  },
  {
    n: '03',
    title: 'Collection day',
    body: 'The collector arrives, clears the scrap, and takes it through licensed handling routes.',
    Icon: IconTruck,
  },
  {
    n: '04',
    title: 'Done — responsibly',
    body: 'Your space is clear and your scrap is handled the right way, not fly-tipped.',
    Icon: IconCheck,
  },
];

const COLLECTOR_STEPS = [
  {
    n: '01',
    title: 'Apply as a collector',
    body: 'Join SnapScrap with your licence details and service area so we can verify your account.',
    Icon: IconBadge,
  },
  {
    n: '02',
    title: 'Browse nearby posts',
    body: 'See local scrap listings that match your vehicle, capacity, and working radius.',
    Icon: IconSearch,
  },
  {
    n: '03',
    title: 'Arrange the job',
    body: 'Confirm access details and collection timing directly with the poster.',
    Icon: IconChat,
  },
  {
    n: '04',
    title: 'Collect & process',
    body: 'Pick up the scrap and move it through your licensed transfer and recycling routes.',
    Icon: IconRecycle,
  },
];

const HIGHLIGHTS = [
  {
    title: 'Free to post',
    body: 'Households and businesses can list scrap at no cost and only proceed when ready.',
  },
  {
    title: 'Licensed matching',
    body: 'Collectors are verified scrap carriers — helping keep collections legal and accountable.',
  },
  {
    title: 'Local & flexible',
    body: 'Arrange collection around your schedule, site access, and how much scrap you have.',
  },
  {
    title: 'Clear next steps',
    body: 'Photos, notes, and postcodes help collectors arrive prepared and finish faster.',
  },
];

const AUDIENCES = [
  {
    title: 'Households',
    body: 'Garage clear-outs, white goods, DIY leftovers, and one-off metal removals.',
    to: '/for-households',
    label: 'For Households →',
  },
  {
    title: 'Businesses',
    body: 'Trade scrap, site clearances, fit-out leftovers, and recurring commercial loads.',
    to: '/for-business',
    label: 'For Business →',
  },
  {
    title: 'Collectors',
    body: 'Get matched with nearby scrap posts and grow licensed collection work.',
    to: '/become-a-collector',
    label: 'Become a Collector →',
  },
];

function StepCard({ step }) {
  const { n, title, body, Icon } = step;
  return (
    <li className="how-step-card">
      <span className="how-step-n" aria-hidden="true">
        {n}
      </span>
      <span className="how-step-icon">
        <Icon />
      </span>
      <h3>{title}</h3>
      <p>{body}</p>
    </li>
  );
}

export default function HowItWorksPage() {
  return (
    <div className="how-page">
      <section className="how-hero" aria-labelledby="how-heading">
        <div className="how-hero-inner">
          <p className="how-kicker">Simple from start to finish</p>
          <h1 id="how-heading">How It Works</h1>
          <p>
            SnapScrap connects people who need scrap collected with licensed local collectors.
            Post for free, arrange a collection, and clear metal the responsible way.
          </p>
          <div className="how-hero-actions">
            <Link className="how-btn" to="/post-scrap">
              Post Scrap →
            </Link>
            <Link className="how-btn how-btn-secondary" to="/become-a-collector">
              Become a Collector
            </Link>
          </div>
        </div>
      </section>

      <section className="how-section" aria-labelledby="how-poster-heading">
        <div className="how-inner">
          <header className="how-header">
            <h2 id="how-poster-heading">If you need scrap collected</h2>
            <p>Four steps from posting to a clear driveway or site</p>
          </header>
          <ol className="how-steps">
            {POSTER_STEPS.map((step) => (
              <StepCard key={step.n} step={step} />
            ))}
          </ol>
        </div>
      </section>

      <section className="how-section how-section-alt" aria-labelledby="how-collector-heading">
        <div className="how-inner">
          <header className="how-header">
            <h2 id="how-collector-heading">If you are a collector</h2>
            <p>Join the network and get matched with nearby scrap jobs</p>
          </header>
          <ol className="how-steps">
            {COLLECTOR_STEPS.map((step) => (
              <StepCard key={`c-${step.n}`} step={step} />
            ))}
          </ol>
        </div>
      </section>

      <section className="how-section" aria-labelledby="how-highlights-heading">
        <div className="how-inner">
          <header className="how-header">
            <h2 id="how-highlights-heading">What makes it straightforward</h2>
            <p>Built for quick listings and reliable licensed collections</p>
          </header>
          <ul className="how-highlights">
            {HIGHLIGHTS.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="how-section how-section-alt" aria-labelledby="how-audience-heading">
        <div className="how-inner">
          <header className="how-header">
            <h2 id="how-audience-heading">Choose your path</h2>
            <p>Jump into the guide that matches how you use SnapScrap</p>
          </header>
          <ul className="how-audience">
            {AUDIENCES.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
                <Link to={item.to}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="how-cta-section" aria-label="Get started call to action">
        <div className="how-inner">
          <div className="how-cta">
            <h2>Ready to get started?</h2>
            <p>Post scrap for free or join as a licensed collector — available online 24/7.</p>
            <div className="how-hero-actions">
              <Link className="how-btn" to="/post-scrap">
                Post Scrap →
              </Link>
              <Link className="how-btn how-btn-secondary" to="/faqs">
                Read FAQs
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
